import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";

const Searched = () => {
  const [searched, setSearched] = useState([]);
  let params = useParams();

  useEffect(() => {
    const getSearched = async (name) => {
      const data = await fetch(
        `https://api.spoonacular.com/recipes/complexSearch?apiKey=${process.env.REACT_APP_API_KEY}&query=${name}`
      );
      const recipes = await data.json();
      setSearched(recipes.results);
    };
    getSearched(params.search);
  }, [params.search]);
  return (
    <Grid>
      {searched.map((item) => {
        return (
          <Card key={item.id}>
            <Link to={`/Recipe/${item.id}`}>
              <img src={item.image} alt={item.title} />
              <h4>{item.title}</h4>
            </Link>
          </Card>
        );
      })}
    </Grid>
  );
};

const Grid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  grid-gap: 1rem;
  margin: 0rem 2rem;
  @media screen and (max-width: 800px) {
    margin: 0rem 1rem;
    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
    align-items: center;
    justify-content: center;
  }
`;
const Card = styled.div`
  cursor: pointer;
  img {
    width: 100%;
    height: 200px;
    border-radius: 3rem;
  }
  a {
    text-decoration: none;
  }
  h4 {
    text-align: center;
    padding: 1rem;
  }
`;
export default Searched;
